import React from "react";
import axios from "axios";

const WelletContext = React.createContext();

function WelletContextProvider({ children }) {
  const widget = window.location.pathname.endsWith('/widget');
  const hostUrlParams = window.location.search; // save the params from the host url, so they can be used for generating a reservation with tracking

  const tickets = axios.create({
    baseURL: import.meta.env.VITE_SALES_API_URL,
  });

  const apis = {
    tickets,
  };

  return (
    <WelletContext.Provider value={{ apis, widget, hostUrlParams }}>{children}</WelletContext.Provider>
  );
}

export { WelletContextProvider };
export default WelletContext;
